// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { SimulationSoftware } from "./SimulationSoftware";
import {
  SimulationSoftwareFromJSON,
  SimulationSoftwareFromJSONTyped,
  SimulationSoftwareToJSON,
  SimulationSoftwareToJSONTyped,
} from "./SimulationSoftware";
import type { Id1 } from "./Id1";
import { Id1FromJSON, Id1FromJSONTyped, Id1ToJSON, Id1ToJSONTyped } from "./Id1";

/**
 *
 * @export
 * @interface Simulation
 */
export interface Simulation {
  /**
   *
   */
  id?: Id1 | null;
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  software?: SimulationSoftware;
  /**
   *
   */
  duration?: string | null;
  /**
   *
   */
  interval?: Array<any> | null;
  /**
   *
   */
  createdAt?: Date | null;
}

/**
 * Check if a given object implements the Simulation interface.
 */
export function instanceOfSimulation(value: object): value is Simulation {
  return true;
}

export function SimulationFromJSON(json: any): Simulation {
  return SimulationFromJSONTyped(json, false);
}

export function SimulationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Simulation {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : Id1FromJSON(json["id"]),
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    software: json["software"] == null ? undefined : SimulationSoftwareFromJSON(json["software"]),
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    interval:
      json["interval"] === undefined
        ? undefined
        : json["interval"] === null
        ? null
        : json["interval"],
    createdAt:
      json["created_at"] === undefined
        ? undefined
        : json["created_at"] === null
        ? null
        : parseDateTime(json["created_at"]),
  };
}

export function SimulationToJSON(json: any): Simulation {
  return SimulationToJSONTyped(json, false);
}

export function SimulationToJSONTyped(
  value?: Simulation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: Id1ToJSON(value["id"]),
    name: value["name"],
    software: SimulationSoftwareToJSON(value["software"]),
    duration: value["duration"],
    interval: value["interval"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
  };
}
